import gql from 'graphql-tag'

export const SET_APPLICATIONS = gql`
  mutation setApplications($applications: [ApplicationInput!]!) {
    setApplications(applications: $applications)
  }
`
